import React from 'react';
import './App.css';
import logo from './logo.png'; // Ruta al logo


function App() {
  return (
    <div className="App">
      <div className="background"></div> {/* Capa de fondo con la imagen */}
      <div className="overlay"></div> {/* Capa oscura */}
      <div className="logo-container">
        <img src={logo} alt="Logo de la marca" className="logo" />
      </div>
    </div>
  );
}

export default App;
